import { Empty, Form } from "antd";
import i18n from "i18next";
import styled from "styled-components";

import {
    FormFieldInputStyle,
    FormFieldLabelStyle,
    HorizontalFormFieldStyle,
    VerticalFormFieldStyle,
} from "../../formFieldLabelPositioning/styles/FormFieldsStyle";
import { withLabelColon } from "../../formFieldLabelPositioning/withLabelColon";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalHostTerminalTable } from "./TerminalHostTerminalTable";

export const TerminalHostTerminalTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const label = withLabelColon(i18n.t(field.translationKeys.label));

    return (
        <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
                // No contracted acquirer requires a Host Terminal ID for this terminal
                const value = getFieldValue(field.name);
                if (!value || value.length === 0) {
                    return (
                        <NonFullWidthColumn>
                            <HorizontalFormFieldStyle>
                                <FormFieldLabelStyle>{label}</FormFieldLabelStyle>
                                <FormFieldInputStyle>
                                    <Empty description={i18n.t("terminals.hostids.empty")} />
                                </FormFieldInputStyle>
                            </HorizontalFormFieldStyle>
                        </NonFullWidthColumn>
                    );
                }

                return (
                    <VerticalFormFieldStyle>
                        <FormFieldLabelStyle>{label}</FormFieldLabelStyle>
                        <FormFieldInputStyle>
                            <Form.Item key={`${field.name}`} name={field.name}>
                                <TerminalHostTerminalTable readOnly={readOnly} />
                            </Form.Item>
                        </FormFieldInputStyle>
                    </VerticalFormFieldStyle>
                );
            }}
        </Form.Item>
    );
};

// Normal fields sit in a Col span={14}/24 before their own 30/70 label/content split applies;
// full-width fields (Col span={24}) need the same 14/24 constraint here to match visually.
export const NonFullWidthColumn = styled.div`
    width: ${(14 / 24) * 100}%;
`;
